import * as components from 'vuetify/lib/components'
import * as directives from 'vuetify/lib/directives'
import Vue from 'vue'


const includedComponents = Object.keys(components)
const includedDirectives = Object.keys(directives)

const excludedComponents = ['VMap', 'VMapAutocompleteService']
const excludedDirectives = []

// Register All Vuetify Components
const VuetifyResolver = () => {
  // console.log('VuetifyResolver Included Components::', includedComponents)
  // console.log('VuetifyResolver Excluded Components::', excludedComponents)
  includedComponents.forEach(componentName => {
    if (componentName.startsWith('V') && !excludedComponents.includes(componentName)) {
      Vue.component(componentName, components[componentName])
    }
  })

  // console.log('VuetifyResolver Included Directives::', includedDirectives)
  // console.log('VuetifyResolver Excluded Directives::', excludedDirectives)
  includedDirectives.forEach(directiveName => {
    if (!excludedDirectives.includes(directiveName)) {
      Vue.directive(directiveName, directives[directiveName])
    }
  })
}

export default VuetifyResolver
